import { useLayoutEffect, useMemo, useRef } from 'react';
import { theme } from '@pocketlaw/tetris';
import { LinkLayer } from 'shared/domains/documents/components/LinkLayer';
import { CanvasLayer } from '../../CanvasLayer';
import { ErrorLayer } from '../../ErrorLayer';
import { TextLayer } from '../../TextLayer';
import { useStrictPDFData } from '../../usePDFData';
import { OuterPage, Page } from './styled';
export function Item(props) {
    const { page, pageNumber, zoom, zoomRef } = props;
    const { scale, spacing, setPageRef } = useStrictPDFData();
    const pageRef = useRef(null);
    const viewport = useMemo(() => page.getViewport({ scale }), [page, scale]);
    const pageHeight = viewport.height * zoom;
    const pageWidth = viewport.width * zoom;
    useLayoutEffect(() => {
        if (pageRef.current) {
            setPageRef(pageNumber, pageRef.current);
            if (pageNumber === 1) {
                zoomRef.current = pageRef.current;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (<OuterPage $height={pageHeight} $width={pageWidth} $spacing={spacing} $borderColor={`color-mix(in srgb, ${theme.semantic.border.default}, transparent 35%)`}>
      <Page $zoom={zoom} ref={pageRef}>
        <CanvasLayer page={page} scale={scale} pageNumber={pageNumber}/>
        <TextLayer page={page} scale={scale}/>
        <LinkLayer page={page} scale={scale}/>
        <ErrorLayer page={page} scale={scale}/>
      </Page>
    </OuterPage>);
}
